export default "__VITE_ASSET__BbGAzQe8__"